export class AngularTablePage {
    page: number = 1;
    itemsPerPage: number = 50;
}


// WEBPACK FOOTER //
// ./src/angular_library/models/angular-table-page.ts